// @flow
import React from 'react'
import Helmet from 'react-helmet'
import graphql from 'graphql-tag'
import styled, { css } from 'styled-components'

import mapProps from '../theme/mapProps'
import {
  Headline,
  ContentRow,
  ViewportRow,
  ViewportContainer,
  ViewportContent,
  PageContainer,
  Container,
  Block,
  Fill,
  Flex,
  FlexChild,
  Title,
  Text,
  Paragraph,
  ViewportRibbon,
  Link,
  Divider
} from '../styleguide'



export default function Template(props) {
  const { data } = props;
  const { markdownRemark } = data // data.markdownRemark holds our post data
  const { frontmatter, html } = markdownRemark

  return (
    <ContentRow>
      <Helmet title={frontmatter.title} />
      <Title scale="4" weight="black" mb="0">
        {frontmatter.title}
      </Title>
      <Divider />
      <Flex justify="between">
        <Title h="2" scale="3" my="0">
          <Link to="/privacy-policy">Privacy Policy</Link>
        </Title>
        <Fill scale="2"/>
        <Title h="2" scale="3" my="0">
          <Link to="/terms-of-service">Terms of Service</Link>
        </Title>
        <Fill scale="1" flex="auto"/>
      </Flex>

      <MarkdownContainer dangerouslySetInnerHTML={{ __html: html }} />

      <h2>{frontmatter.date}</h2>
    </ContentRow>
  )
}

export const pageQuery = graphql`
  query LegalByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
      }
    }
  }
`;

const MarkdownContainer = styled.div`
  &, & p {
    white-space: normal
  }
`



// WEBPACK FOOTER //
// ./src/templates/legal.js